(function() {
    'use strict';

    angular.module( APP_ID )
        .factory( 'MarketoForms', [ '$window', '$q', '$ocLazyLoad', MarketoFormsService ]);


    /**
     * Lazy loads Marketo Forms Manager library.
     *
     * @param {ng.IQService} $q
     *
     * @returns {MarketoForms}
     */
    function MarketoFormsService(
        $window,
        $q,
        $ocLazyLoad
    ){


        var MARKETO_MANAGER_JS_URL = 'https://www.wgtn.ac.nz/__data/assets/git_bridge/0004/1514929/forms.toolkit.js';





        var MarketoFormManager;



        var serviceApi = {
            initForm: initForm,
        };



        ////////////////////////////////////////////////////////////////////

        return serviceApi; // Expose API

        ////////////////////////////////////////////////////////////////////



        function initForm( marketoFormId, containerDomElement, configObject ) {
            var defer = $q.defer();


            function createNewForm() {
                MarketoFormManager.initForm( marketoFormId, containerDomElement, function( form ) {
                    if ( form ) {
                        defer.resolve( form );
                    } else {
                        defer.reject( 'An instantiation issue has probably occured in the Toolkit\'s Marketo Manager script. The form will not be created!' );
                    }
                }, configObject );
            }


            if ( MarketoFormManager ) {
                createNewForm();
            } else {
                // Init Form manager's scripts + resolve.
                $ocLazyLoad.load( MARKETO_MANAGER_JS_URL ).then( function() {
                    MarketoFormManager = $window.toolkitForms;
                    createNewForm();
                }).catch( function( err ) {
                    defer.reject( 'Unable to load the Toolkit\'s Marketo Manager script.', err );
                });
            }

            return defer.promise;
        }

    }
})();
